import { render, staticRenderFns } from "./init-online-payment.vue?vue&type=template&id=18938f7c&scoped=true"
import script from "./init-online-payment.vue?vue&type=script&lang=js"
export * from "./init-online-payment.vue?vue&type=script&lang=js"
import style0 from "./init-online-payment.vue?vue&type=style&index=0&id=18938f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18938f7c",
  null
  
)

export default component.exports